import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/jugador/edad`;

const CACHE_KEY = 'jugador_edad_cache';
const CACHE_EXPIRY_HOURS = 24;

// Función helper para obtener del caché
const getCachedEdad = (idJugador, idTemporada) => {
  try {
    const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
    const key = `${idJugador}_${idTemporada}`;
    const cached = cache[key];
    
    if (cached && cached.timestamp) {
      const now = Date.now();
      const expiryTime = cached.timestamp + (CACHE_EXPIRY_HOURS * 60 * 60 * 1000);
      
      if (now < expiryTime) {
        return cached.data;
      }
    }
  } catch (error) {
    // silently handled
  }
  return null;
};

// Función helper para guardar en el caché
const setCachedEdad = (idJugador, idTemporada, data) => {
  try {
    const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
    const key = `${idJugador}_${idTemporada}`;
    
    cache[key] = {
      data,
      timestamp: Date.now(),
      fechaObtencion: new Date().toISOString()
    };
    
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  } catch (error) {
    // silently handled
  }
};

// Función para obtener la edad del jugador con caché
export const getEdadJugador = async (idJugador, idTemporada, navigate) => {
  // Intentar obtener del caché primero
  const cached = getCachedEdad(idJugador, idTemporada);
  if (cached) {
    return cached;
  }

  try {
    const response = await fetchWithAuth(
      `${API_URL}/${idJugador}/${idTemporada}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      
      // Guardar en caché para futuras consultas
      setCachedEdad(idJugador, idTemporada, data);
      
      return data;
    }

    throw new Error("Error al obtener la edad del jugador");
  } catch (error) {
    throw error;
  }
};
